export default __webpack_public_path__ + "static/media/three.5ef2d01f.svg";